import { ReactNode } from 'react'

type Props = {
    left?: ReactNode
    center?: ReactNode
    right?: ReactNode
}

export const Bar = ({ left, center, right }: Props) => (
    <div className="grid h-full grid-cols-[2fr,min-content,1fr] items-center gap-1">
        <div className="h-full justify-self-start">{left ?? <div />}</div>
        <div className="flex h-full items-center">{center ?? <div />}</div>
        <div className="flex h-full items-center justify-self-end">{right ?? <div />}</div>
    </div>
)
